import { Droplet, LogOut, UserCircle } from 'lucide-react'

const ROLE_LABELS = {
  superadmin: 'Super Admin',
  admin: 'Admin',
  manager: 'Manager',
}

export default function NavBar({ currentUser, onLogout, onProfileClick }) {
  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 sm:h-16 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
            <Droplet className="w-4 h-4 text-white" />
          </div>
          <div>
            <span className="text-lg sm:text-xl font-bold text-gray-800 leading-none">PetroTrack</span>
            <p className="text-xs text-gray-500 leading-none mt-0.5">
              {ROLE_LABELS[currentUser.role]}: {currentUser.name}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={onProfileClick}
            className="flex items-center space-x-2 bg-gray-50 hover:bg-gray-100 active:bg-gray-200 text-gray-600 font-semibold px-3 sm:px-4 min-h-[44px] rounded-lg transition duration-200"
          >
            <UserCircle className="w-4 h-4" />
            <span className="hidden sm:inline text-sm">Profile</span>
          </button>

          <button
            onClick={onLogout}
            className="flex items-center space-x-2 bg-red-50 hover:bg-red-100 active:bg-red-200 text-red-600 font-semibold px-3 sm:px-4 min-h-[44px] rounded-lg transition duration-200"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline text-sm">Logout</span>
          </button>
        </div>
      </div>
    </nav>
  )
}
